import React, { Component } from 'react';
import { Editor } from '@tinymce/tinymce-react';

class CommonEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.initialValue || '',
    };
    this.editorRef = React.createRef();
  }

 static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.initialValue !== prevState.lastPropValue) {
      return {
        value: nextProps.initialValue || '',
        lastPropValue: nextProps.initialValue,
      };
    }
    return null;
  }

  handleEditorChange = (content) => {
    this.setState({ value: content });

    // Pass to parent
    if (this.props.onChange) {
      this.props.onChange(content);
    }
  };

  render() {
    const baseConfig = {
      height: this.props.height || 188,
      menubar: this.props.menubar !== undefined ? this.props.menubar : true,
      plugins: [
        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
        'preview', 'anchor', 'searchreplace', 'visualblocks', 'code',
        'fullscreen', 'insertdatetime', 'media', 'table', 'help', 'wordcount'
      ],
      toolbar: this.props.toolbar || 
        'undo redo | blocks | bold italic underline | ' +
        'alignleft aligncenter alignright | bullist numlist | ' +
        'link image media table | removeformat | help',

      convert_urls: this.props.convert_urls !== undefined ? this.props.convert_urls : false,
      images_reuse_filename: true,
    };

    if (this.props.images_upload_handler) {
      baseConfig.images_upload_handler = this.props.images_upload_handler;
    }

    if (this.props.enableTableWrap) {
      baseConfig.setup = (editor) => {
        const wrapTables = () => {
          const tables = editor.getBody().querySelectorAll("table");
          tables.forEach(table => {
            if (!table.parentNode.classList.contains("scrollable_table_h")) {
              const wrapper = editor.getDoc().createElement("div");
              wrapper.className = "scrollable_table_h";
              wrapper.style.cssText = "width: 100%; overflow-x: auto; -webkit-overflow-scrolling: touch;";
              table.parentNode.insertBefore(wrapper, table);
              wrapper.appendChild(table);
            }
          });
        };

        editor.on('init', wrapTables);
        editor.on('SetContent', () => setTimeout(wrapTables, 100));
        editor.on('Paste', () => setTimeout(wrapTables, 100));
        editor.on('ExecCommand', (e) => {
          if (e.command === "mceInsertTable") setTimeout(wrapTables, 100);
        });
      };
    }

    return (
      <Editor
        ref={this.editorRef}
        value={this.state.value}           
        init={baseConfig}
        onEditorChange={this.handleEditorChange}
        rollback={0}
        onInit={this.props.onInit}
      />
    );
  }
}

export default CommonEditor;

// import React, { Component } from "react";
// import { Editor } from "@tinymce/tinymce-react";

// class CommonEditor extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       value: props.initialValue || "",
//     };
//     this.editorRef = React.createRef();
//   }

//   // Simple & Clean - Only update when parent sends new initialValue (for Edit mode)
//   static getDerivedStateFromProps(nextProps, prevState) {
//     if (nextProps.initialValue !== prevState.lastPropValue) {
//       return {
//         value: nextProps.initialValue || "",
//         lastPropValue: nextProps.initialValue,
//       };
//     }
//     return null;
//   }

//   handleEditorChange = (content) => {
//     this.setState({ value: content });

//     // Pass to parent
//     if (this.props.onChange) {
//       this.props.onChange(content);
//     }
//   };

//   render() {
//     const baseConfig = {
//       height: this.props.height || 188,
//       // apiKey: "qervlpht4div5arm10y23zq72oecnzo4zw8bdrjyd1js0mu7",
//       menubar: this.props.menubar !== undefined ? this.props.menubar : true,
//       plugins: [
//         "advlist",
//         "autolink",
//         "lists",
//         "link",
//         "image",
//         "charmap",
//         "preview",
//         "anchor",
//         "searchreplace",
//         "visualblocks",
//         "code",
//         "fullscreen",
//         "insertdatetime",
//         "media",
//         "table",
//         "help",
//         "wordcount", 
//         // Core editing features
//         // "anchor",
//         // "autolink",
//         // "charmap",
//         // "codesample",
//         // "emoticons",
//         // "link",
//         // "lists",
//         // "media",
//         // "searchreplace",
//         // "table",
//         // "visualblocks",
//         // "wordcount",
//         // // Your account includes a free trial of TinyMCE premium features
//         // "checklist",
//         // "mediaembed",
//         // "casechange",
//         // "formatpainter",
//         // "pageembed",
//         // "a11ychecker",
//         // "tinymcespellchecker",
//         // "permanentpen",
//         // "powerpaste",
//         // "advtable",
//         // "advcode",
//         // "advtemplate",
//         // "tinymceai",
//         // "uploadcare",
//         // "mentions",
//         // "tinycomments",
//         // "tableofcontents",
//         // "footnotes",
//         // "mergetags",
//         // "autocorrect",
//         // "typography",
//         // "inlinecss",
//         // "markdown",
//         // "importword",
//         // "exportword",
//         // "exportpdf",
//       ],
//       toolbar:
//         this.props.toolbar ||
//         "undo redo | blocks | bold italic underline | " +
//           "alignleft aligncenter alignright | bullist numlist | " +
//           "link image media table | removeformat | help",
//       // tinycomments_mode: "embedded",
//       // tinycomments_author: this.props.tinycomments_author || "Author name",
//       // mergetags_list: [
//       //   { value: "First.Name", title: "First Name" },
//       //   { value: "Email", title: "Email" },
//       // ],
//       // tinymceai_token_provider: async () => {
//       //   await fetch(
//       //     `https://demo.api.tiny.cloud/1/qervlpht4div5arm10y23zq72oecnzo4zw8bdrjyd1js0mu7/auth/random`,
//       //     { method: "POST", credentials: "include" },
//       //   );
//       //   return {
//       //     token: await fetch(
//       //       `https://demo.api.tiny.cloud/1/qervlpht4div5arm10y23zq72oecnzo4zw8bdrjyd1js0mu7/jwt/tinymceai`,
//       //       { credentials: "include" },
//       //     ).then((r) => r.text()),
//       //   };
//       // },
//       // uploadcare_public_key: "a0272502d91b33ae9c0f",
//       convert_urls:
//         this.props.convert_urls !== undefined ? this.props.convert_urls : false,
//       images_reuse_filename: true,
//     };

//     if (this.props.images_upload_handler) {
//       baseConfig.images_upload_handler = this.props.images_upload_handler;
//     }

//     if (this.props.enableTableWrap) {
//       baseConfig.setup = (editor) => {
//         const wrapTables = () => {
//           const tables = editor.getBody().querySelectorAll("table");
//           tables.forEach((table) => {
//             if (!table.parentNode.classList.contains("scrollable_table_h")) {
//               const wrapper = editor.getDoc().createElement("div");
//               wrapper.className = "scrollable_table_h";
//               wrapper.style.cssText =
//                 "width: 100%; overflow-x: auto; -webkit-overflow-scrolling: touch;";
//               table.parentNode.insertBefore(wrapper, table);
//               wrapper.appendChild(table);
//             }
//           });
//         };

//         editor.on("init", wrapTables);
//         editor.on("SetContent", () => setTimeout(wrapTables, 100));
//         editor.on("Paste", () => setTimeout(wrapTables, 100));
//         editor.on("ExecCommand", (e) => {
//           if (e.command === "mceInsertTable") setTimeout(wrapTables, 100);
//         });
//       };
//     }

//     return (
//       <Editor
//         ref={this.editorRef}
//         value={this.state.value}
//         init={baseConfig}
//         onEditorChange={this.handleEditorChange}
//         rollback={0}
//         onInit={this.props.onInit}
//       />
//     );
//   }
// }

// export default CommonEditor;